import {
  MODIFY_SUPERVISED_USERS_FAIL,
  MODIFY_SUPERVISED_USERS_SUCCESS,
  SEARCH_SUPERVISED_USERS_FAIL,
  SEARCH_SUPERVISED_USERS_START,
  SEARCH_SUPERVISED_USERS_SUCCESS,
  SUPERVISED_USERS_CANCEL_BULK_ACTION,
  SUPERVISED_USERS_HYDRATE_ACTIVE_DYNAMIC_FILTERS,
  SUPERVISED_USERS_REFRESH,
  SUPERVISED_USERS_RESET_DYNAMIC_FILTERS,
  SUPERVISED_USERS_SEARCH_FILTER_ITEMS,
  SUPERVISED_USERS_SEARCH_FILTER_ITEMS_START,
  SUPERVISED_USERS_SEARCH_FILTER_ITEMS_SUCCESS,
  SUPERVISED_USERS_SEARCH_FILTER_ITEMS_FAIL,
  SUPERVISED_USERS_SET_LOADING,
  SUPERVISED_USERS_SET_ACTIVE_DYNAMIC_FILTERS,
  USER_HAS_PERMISSIONS_SUCCESS,
} from 'actions/userProfile';

import {
  getListPageSuccessNewData,
  getListPageSuccessNewLinks,
} from '../utils';

export const defaultState = {
  loading: true,
  data: [],
  links: {},
  dataLoaded: false,
  error: false,
  sites: {
    activeItems: [],
    count: 0,
    data: [],
    loading: false,
    total: 0,
  },
  shouldCancel: false,
  canSuperviseUsers: false,
  currentUserId: null,
  currentUserPermissions: [],
};

export default function supervisedUsers(state = defaultState, action) {
  switch (action.type) {
    case SEARCH_SUPERVISED_USERS_START: {
      const newState = {
        ...state,
        dataLoaded: false,
        currentUserId: action.currentUserId,
      };
      if (state.currentUserId !== action.currentUserId) {
        newState.loading = true;
        newState.data = [];
      }
      return newState;
    }
    case SEARCH_SUPERVISED_USERS_SUCCESS: {
      const { data, links, total } = action.payload;

      return {
        ...state,
        ...{
          data: getListPageSuccessNewData(state, data, links),
          links: getListPageSuccessNewLinks(links),
          total,
          dataLoaded: true,
          loading: false,
          error: false,
        },
      };
    }
    case SUPERVISED_USERS_SET_LOADING: {
      return {
        ...state,
        loading: true,
      };
    }
    case SUPERVISED_USERS_REFRESH: {
      return {
        ...state,
        data: [], // Require reload
        loading: true,
      };
    }
    case SEARCH_SUPERVISED_USERS_FAIL: {
      return {
        ...state,
        loading: false,
        error: true,
      };
    }
    case SUPERVISED_USERS_HYDRATE_ACTIVE_DYNAMIC_FILTERS: {
      const [storeKey] = Object.keys(action.payload);
      const value = action.payload[storeKey];
      const count = value.length;

      return {
        ...state,
        [storeKey]: {
          data: [...value],
          count,
          total: count,
          loading: false,
        },
      };
    }
    case SUPERVISED_USERS_SEARCH_FILTER_ITEMS: {
      return state;
    }
    case SUPERVISED_USERS_SEARCH_FILTER_ITEMS_START: {
      const { endpoint: storeKey } = action.payload;
      return {
        ...state,
        [storeKey]: {
          ...state[storeKey],
          loading: true,
        },
      };
    }
    case SUPERVISED_USERS_SEARCH_FILTER_ITEMS_SUCCESS: {
      const { count, data, total, endpoint: storeKey } = action.payload;

      return {
        ...state,
        [storeKey]: {
          ...state[storeKey],
          count,
          data,
          loading: false,
          total,
        },
      };
    }
    case SUPERVISED_USERS_SEARCH_FILTER_ITEMS_FAIL: {
      return {
        ...state,
        sites: {
          ...state.sites,
          loading: false,
        },
      };
    }

    case SUPERVISED_USERS_SET_ACTIVE_DYNAMIC_FILTERS: {
      const { key, items } = action.payload;

      const activeItems = [
        ...state[key].activeItems,
        ...items.filter(
          item => !state[key].activeItems.find(a => a.id === item.id),
        ),
      ];

      return {
        ...state,
        [key]: {
          ...state[key],
          activeItems,
        },
      };
    }
    case SUPERVISED_USERS_RESET_DYNAMIC_FILTERS: {
      const { key, items } = action.payload;
      return {
        ...state,
        [key]: {
          ...state[key],
          data: [],
          activeItems: items,
        },
      };
    }
    case SUPERVISED_USERS_CANCEL_BULK_ACTION: {
      return {
        ...state,
        shouldCancel: true,
      };
    }
    case MODIFY_SUPERVISED_USERS_FAIL:
    case MODIFY_SUPERVISED_USERS_SUCCESS: {
      return {
        ...state,
        shouldCancel: false,
      };
    }
    case USER_HAS_PERMISSIONS_SUCCESS: {
      const user = action.payload.data;
      return {
        ...state,
        canSuperviseUsers: user.length && user[0].id === state.currentUserId,
      };
    }
    default:
      return state;
  }
}
